import { useState } from 'react';
import { normalizeScan } from '@civilos/domain';
import { api } from '../shared/api.ts';
import { fmtDateTime } from '../shared/format.ts';
import { Badge, Card, Empty, ErrorBox, Field, useAction, useLoad } from '../shared/ui.tsx';

/** CUST-009: bulk return to court with manifest, receipt and exceptions. */
export function CourtReturns() {
  const meta = useLoad(() => api.get('/api/meta'));
  const list = useLoad(() => api.get('/api/court-returns'));
  const [courtId, setCourtId] = useState('');
  const [numbers, setNumbers] = useState('');
  const [last, setLast] = useState<any>(null);
  const a = useAction();
  return (
    <div className="stack">
      <h1>Court returns</h1>
      <Card title="New return batch">
        <form
          className="stack"
          onSubmit={(e) => {
            e.preventDefault();
            a.run(async () => {
              const r = await api.post('/api/court-returns', { courtId: courtId || undefined, paperNumbers: numbers.split(/\s+/).map(normalizeScan).filter(Boolean) });
              setLast(r);
              setNumbers('');
              list.reload();
            });
          }}
        >
          <Field label="Court">
            <select value={courtId} onChange={(e) => setCourtId(e.target.value)}>
              <option value="">—</option>
              {meta.data?.courts.map((c: any) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </select>
          </Field>
          <Field label="Scan papers (one per line)" hint="Only papers with a signed affidavit in office custody are included; others are listed as exceptions.">
            <textarea rows={5} value={numbers} onChange={(e) => setNumbers(e.target.value)} className="mono" />
          </Field>
          <button className="btn primary" disabled={a.busy || !numbers.trim()}>
            Create manifest & check out
          </button>
        </form>
        {last && (
          <div className="stack sm">
            <strong>Manifest {last.manifestNumber}</strong>
            <span>{last.included.length} included</span>
            {last.exceptions.map((x: any) => (
              <div key={x.paperNumber}>
                <Badge tone="warn">exception</Badge> <span className="mono">{x.paperNumber}</span> — {x.exception}
              </div>
            ))}
          </div>
        )}
        <ErrorBox error={a.error} />
      </Card>
      <Card title="Manifests">
        {!list.data?.manifests.length ? (
          <Empty>No court returns yet.</Empty>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Manifest</th>
                <th>Court</th>
                <th>Papers</th>
                <th>Checked out</th>
                <th>Court receipt</th>
              </tr>
            </thead>
            <tbody>
              {list.data.manifests.map((m: any) => (
                <tr key={m.id}>
                  <td className="mono">{m.manifest_number}</td>
                  <td>{m.court_name ?? '—'}</td>
                  <td>{m.paper_count}</td>
                  <td>{fmtDateTime(m.checked_out_at)}</td>
                  <td>
                    {m.received_at ? (
                      `${fmtDateTime(m.received_at)} — ${m.signer_name} (${m.signature_method})`
                    ) : (
                      <button
                        className="btn sm"
                        onClick={() => {
                          const signer = window.prompt('Court signer name');
                          if (!signer) return;
                          const method = window.confirm('Signed electronically? (Cancel = signed on paper)') ? 'electronic' : 'paper';
                          a.run(async () => {
                            await api.post(`/api/court-returns/${m.id}/receive`, { signerName: signer, signatureMethod: method });
                            list.reload();
                          });
                        }}
                      >
                        Record court receipt
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
    </div>
  );
}
